import React, { Component } from 'react';
import Breadcrumb from '../UI/Breadcrumb';



class SingleSignupCodes extends Component {

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Single Signup Codes</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <Breadcrumb from={[{link: '/user-relationship/promotional-codes-management', label: 'Personal Credit Codes'}]} current="Single Signup Codes"/>
                </div>

                <div className="container box inner-padding mb-15">
                    <div className="box-body">
                        <div className="row justify-between">
                            <div className="col-xs-6 pr-70">
                                <ul className="w-700">
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Codes</p>
                                        <p className="color-primary mt-5">564</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Discount</p>
                                        <p className="color-primary mt-5">Free Credit</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Expiry Date</p>
                                        <p className="color-primary mt-5">2018-05-23</p>
                                    </li>
                                    <li className="py-15">
                                        <p className="font-sm color-grey50">Users</p>
                                        <ul className="tags mt-20">
                                            <li><span>Ashot Simonyan</span></li>
                                            <li><span>Ashot Simonyan</span></li>
                                            <li><span>Ashot Simonyan</span></li>
                                            <li><span>Ashot Simonyan</span></li>
                                        </ul>
                                    </li>
                                    <li className="py-15">
                                        <p className="display-block mt-5 underline pointer" to='/user-relationship/users/id/ratings'>Track The Usage</p>
                                    </li>
                                    <div className="table py-15">
                                        <table>
                                            <thead>
                                            <tr>
                                                <th>Used</th>
                                                <th>Not Used</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Lilit Safaryan</td>
                                                <td>Lilit Safaryan</td>
                                            </tr>
                                            <tr>
                                                <td>Ashot Simonyan</td>
                                                <td>Ashot Simonyan</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default SingleSignupCodes;



// WEBPACK FOOTER //
// ./src/components/User-relationship/SingleSignupCodes.js